import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ExamdojoAuthService } from '@examdojo/auth';
import { SyllabusQuery, SyllabusUserSubscriptionQuery } from '@examdojo/category/v2';
import { ErrorHandlerService } from '@examdojo/error-handling';
import { ExamDateService } from '@examdojo/exam-date';
import { combineLatest, distinctUntilChanged, EMPTY, switchMap } from 'rxjs';

@Injectable()
export class ExamDatesEffectService {
  constructor(
    private readonly examDateService: ExamDateService,
    private readonly syllabusQuery: SyllabusQuery,
    private readonly syllabusUserSubscriptionQuery: SyllabusUserSubscriptionQuery,
    private readonly errorHandlerService: ErrorHandlerService,
    private readonly examdojoAuthService: ExamdojoAuthService,
  ) {
    this.fetchExamDatesWhileLoggedIn().pipe(takeUntilDestroyed()).subscribe();
  }

  // Exam dates are not readable by anon, and the stores this listens to still emit once the session has ended.
  private fetchExamDatesWhileLoggedIn() {
    return this.examdojoAuthService.isLoggedIn$.pipe(
      distinctUntilChanged(),
      switchMap((isLoggedIn) => (isLoggedIn ? this.fetchExamDatesWhenSyllabusChanges() : EMPTY)),
    );
  }

  private fetchExamDatesWhenSyllabusChanges() {
    return combineLatest([
      this.syllabusQuery.activeIdAndCourseLevel$,
      this.syllabusUserSubscriptionQuery.activeCourseExamDateId$.pipe(distinctUntilChanged()),
    ]).pipe(
      switchMap(([{ syllabusId, courseLevel }, userExamDateId]) =>
        this.examDateService.fetchAll({
          syllabusAndCourseLevels: { syllabusId, courseLevel },
          includeIds: userExamDateId || undefined,
        }),
      ),
      this.errorHandlerService.catchHttpErrors(() => EMPTY),
    );
  }
}
